module.exports = __webpack_public_path__ + "img/image-error-no-legend.de681199.svg";